import { ARTICLE_TYPES } from "@consts";

export default {
	name: "LatestArticles",
	props: {
		articles: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			ARTICLE_TYPES,
		};
	},
};
